import { render, staticRenderFns } from "./IntraoralAddDialog.vue?vue&type=template&id=f408bd8e&scoped=true&"
import script from "./IntraoralAddDialog.vue?vue&type=script&lang=js&"
export * from "./IntraoralAddDialog.vue?vue&type=script&lang=js&"
import style0 from "./IntraoralAddDialog.vue?vue&type=style&index=0&id=f408bd8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f408bd8e",
  null
  
)

export default component.exports